/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Import_Select_File_LabelInputs */

const en_subtitle_import_select_file_label = /** @type {(inputs: Subtitle_Import_Select_File_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select Subtitle File`)
};

const fr_subtitle_import_select_file_label = /** @type {(inputs: Subtitle_Import_Select_File_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selectionner le fichier de sous-titres`)
};

const de_subtitle_import_select_file_label = /** @type {(inputs: Subtitle_Import_Select_File_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untertiteldatei auswählen`)
};

const it_subtitle_import_select_file_label = /** @type {(inputs: Subtitle_Import_Select_File_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona file sottotitoli`)
};

const ru_subtitle_import_select_file_label = /** @type {(inputs: Subtitle_Import_Select_File_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите файл субтитров`)
};

const es_subtitle_import_select_file_label = /** @type {(inputs: Subtitle_Import_Select_File_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar archivo de subtítulos`)
};

const zh_cn2_subtitle_import_select_file_label = /** @type {(inputs: Subtitle_Import_Select_File_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择字幕文件`)
};

const ja_subtitle_import_select_file_label = /** @type {(inputs: Subtitle_Import_Select_File_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕ファイルを選択`)
};

const hi_subtitle_import_select_file_label = /** @type {(inputs: Subtitle_Import_Select_File_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपशीर्षक फ़ाइल चुनें`)
};

const pt_pt2_subtitle_import_select_file_label = /** @type {(inputs: Subtitle_Import_Select_File_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione o arquivo de legenda`)
};

/**
* | output |
* | --- |
* | "Select Subtitle File" |
*
* @param {Subtitle_Import_Select_File_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_import_select_file_label = /** @type {((inputs?: Subtitle_Import_Select_File_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Import_Select_File_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_import_select_file_label(inputs)
	if (locale === "de") return de_subtitle_import_select_file_label(inputs)
	if (locale === "it") return it_subtitle_import_select_file_label(inputs)
	if (locale === "ru") return ru_subtitle_import_select_file_label(inputs)
	if (locale === "es") return es_subtitle_import_select_file_label(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_import_select_file_label(inputs)
	if (locale === "ja") return ja_subtitle_import_select_file_label(inputs)
	if (locale === "hi") return hi_subtitle_import_select_file_label(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_import_select_file_label(inputs)
	return en_subtitle_import_select_file_label(inputs)
});